<!-- server-error-page.component.html -->
<div class="server-error-container">
    <!-- Floating decorative shapes -->
    <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
    </div>

    <div class="error-content">
        <!-- Modern SVG Icon -->
        <div class="error-icon">
            <div class="pulse-ring"></div>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#e74c3c" stroke-width="2" fill="#ffe5e5" />
                <path d="M12 8V12" stroke="#e74c3c" stroke-width="2.5" stroke-linecap="round" />
                <circle cx="12" cy="16" r="1" fill="#e74c3c" />

                <!-- Server icon inside -->
                <g transform="translate(7, 6)">
                    <rect x="0" y="0" width="10" height="3" rx="0.5" fill="#e74c3c" opacity="0.3" />
                    <rect x="0" y="4" width="10" height="3" rx="0.5" fill="#e74c3c" opacity="0.3" />
                    <rect x="0" y="8" width="10" height="3" rx="0.5" fill="#e74c3c" opacity="0.3" />
                    <circle cx="2" cy="1.5" r="0.5" fill="white" />
                    <circle cx="2" cy="5.5" r="0.5" fill="white" />
                    <circle cx="2" cy="9.5" r="0.5" fill="white" />
                </g>
            </svg>
        </div>

        <h1>Server Error</h1>
        <p>We're sorry, but our server is currently experiencing issues.</p>
        <p>Please try again later or contact support if the problem persists.</p>

        <button (click)="retry()" [disabled]="isRetrying">
            <svg *ngIf="!isRetrying" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="display: inline-block; vertical-align: middle; margin-right: 8px;">
                <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.3051 3 16.4077 3.91789 17.9923 5.41161"
                    stroke="white" stroke-width="2" stroke-linecap="round" />
                <path d="M21 3V8H16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span *ngIf="!isRetrying">Try Again</span>
            <span *ngIf="isRetrying">Testing Connection...</span>
        </button>

        <!-- Support Contact Section -->
        <div class="support-section">
            <div class="support-title">Need Help?</div>
            <div class="support-contacts">
                <a href="mailto:support@yourcompany.com" class="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 8L10.89 13.26C11.5 13.67 12.5 13.67 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z"
                            style="stroke: var(--theme-primary-light)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>support@rampiere.com</span>
                </a>
            </div>
        </div>
    </div>
</div>